import { FiShoppingCart } from "react-icons/fi";
import { OffCanvas, CardOrder } from "../../Components";
import { useContext, useEffect } from "react";
import { StoreContextMain } from "../../Context";
import { useChekingAuth } from "../../Auth";
import { useNavigate } from "react-router-dom";
import { alertDialog } from "../../Helpers/Alerts";

/*
Este es el carrito de compra, que sale el header, para visualizar los arituclos rápidamente
*/
export const Car = () => {
  const { store } = useContext(StoreContextMain);
  
  const { logged } = useChekingAuth();

  const navigate = useNavigate();

  useEffect( () => {
    if (!logged) {
      navigate('/', {replace: true})
    }

  }, [logged, navigate] )

  const handleNavigate = () => {
    if (store.length <= 0 ) {
      return alertDialog('No existen productos seleccionados, \n favor de agregar', 'Entendido', '')
    }
    navigate("/payment/details-payment");
  };

  return (
    <>
      <OffCanvas
        iconMain={
          <>
            <FiShoppingCart className={"fs-3"} />
            <span
              className="position-absolute start-50 translate-middle bg-danger border border-light rounded-circle"
              style={{
                top: "5px",
                padding: "0.25rem",
                display: store.length > 0 ? "block" : "none",
              }}
            >
              <span className="visually-hidden">New</span>
            </span>
          </>
        }
        title={
          <>
            <h5 className="d-flex m-auto align-items-center">
              <FiShoppingCart className={"fs-3 mx-2 me-3"} />
              Mi Carrito
            </h5>
          </>
        }
        footer={
          <div className="d-flex justify-content-center mb-3">
            <button onClick={handleNavigate} className={"btn btn-primary"}>
              Llevar acabo la compra
            </button>
          </div>
        }
      >
        {store?.map((item, index) => (
          <CardOrder
                key={index}
                id={item.id}
                title={item.title}
                image={item.image}
                price={item.price}
                color={item.color}
                size={item.size}
                amount={item.amount}
                amount_max={item.amount_max}
                enableFeacture={false}
          />
        ))}
      </OffCanvas>
    </>
  );
};
